import Marquee from "react-fast-marquee";

const items = ["Beachfront Weddings", "Boat Parties", "Backyard Soirées", "Corporate Events", "Craft Cocktails", "Native Botanicals"];

export const BrandMarquee = () => (
  <div data-testid="brand-marquee" className="bg-seafoam py-8 border-y border-sand overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-ocean text-3xl md:text-5xl px-8 tracking-tight">{it}</span>
          <span className="text-coral text-2xl">✳</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default BrandMarquee;
